<div class="common-meta">
  <div class="row input">
    @switch (metaInput.readonly) {
      @case (true) {
        <app-text [formGroup]="$safeNavigationMigration(model()?.meta.formGroup)" [meta]="metaInput" [model]="$safeNavigationMigration(model()?.type?.input?.name)"></app-text>
      }
      @default {
        <app-select [formGroup]="$safeNavigationMigration(model()?.meta.formGroup)" [meta]="metaInput" [model]="$safeNavigationMigration(model()?.type?.inputId)" (change)="onInput($event)"></app-select>
      }
    }
  </div>
  <div class="row">
    <app-text [formGroup]="$safeNavigationMigration(model()?.meta.formGroup)" [model]="$safeNavigationMigration(model()?.type?.name)" [meta]="metaName"></app-text>
  </div>
</div>
